import { createApp, h, type App } from 'vue';
import RightAsideComponent from './ResultsDrawer.vue';
import type { IRightListComponentData } from '@/types';
import { i18n } from '@/infrastructure/locales'
import { SafeHtmlPlugin } from '@eureka/shared/safe-html-plugin';
export interface RightAsideOptions {
    title: string;
    data?: IRightListComponentData
    onClose?: () => void;
    disabledBatchSave?: boolean;
    footerField?: string;
}

export function openRightAside(
    options: RightAsideOptions
): Promise<boolean | undefined> {
    const html = window.parent.document.querySelector('html')
    html?.setAttribute('style', 'overflow:hidden')
    const div = document.createElement('div');
    div.setAttribute('data-theme', 'patsnapRD');
    document.body.appendChild(div);

    const unmountApp = (app: App<Element>) => {
        div.remove()
        app.unmount();
        html?.removeAttribute('style')
    };
    const promise = new Promise<boolean | undefined>((resolve) => {
        const app = createApp({
            render() {
                return h(RightAsideComponent, {
                    ...options,
                    closeCallback: () => {
                        options.onClose?.();
                        resolve(undefined);
                        unmountApp(app);
                    },
                });
            },
        });
        app.use(i18n)
        app.use(SafeHtmlPlugin)
        app.mount(div);
    });

    return promise;
}
